/**
 * `getDocs` instrumentado: informa cuántos documentos devolvió cada consulta.
 *
 * Sirve para los archivos que hacen muchas consultas (ReportesAA, por ejemplo)
 * y donde no conviene tocar cada llamada una por una: basta con cambiar el
 * import de `getDocs` por este wrapper y todas las lecturas quedan medidas.
 *
 * El nombre de la colección se deduce de la ruta del propio documento
 * (`asistencia/123/registros/abc` -> `registros`), que es parte de la API
 * pública del SDK.
 */

import { getDocs as getDocsOriginal } from "firebase/firestore";
import { registrarLecturas, obtenerOrigenConsumo } from "./consumoLecturas";

const deducirColeccion = (snapshot) => {
  const conteo = new Map();
  for (const doc of snapshot.docs || []) {
    const partes = String(doc.ref?.path || "").split("/");
    if (partes.length < 2) continue;
    const coleccion = partes[partes.length - 2];
    conteo.set(coleccion, (conteo.get(coleccion) || 0) + 1);
  }
  let mejor = null;
  let maximo = 0;
  for (const [coleccion, n] of conteo) {
    if (n > maximo) {
      mejor = coleccion;
      maximo = n;
    }
  }
  return mejor || "desconocida";
};

export async function getDocs(queryRef, opciones) {
  // El origen se fija ANTES de lanzar la consulta: si no, varias pantallas
  // cargando a la vez harían que la última en llamar a `establecerOrigenConsumo`
  // se quedase con la atribución de todas las lecturas.
  const origen = obtenerOrigenConsumo();
  const snapshot = await getDocsOriginal(queryRef, opciones);
  try {
    const total = snapshot?.size || 0;
    if (total > 0) {
      registrarLecturas({ [deducirColeccion(snapshot)]: total }, { origen });
    }
  } catch {
    // Nunca romper la consulta por el tracking.
  }
  return snapshot;
}

export default getDocs;
